import orderDetailManagerList from "./order-detail-manager-list/OrderDetailManagerList.vue";
import medicinesList from "./medicines-grid/MedicinesList.vue";

export default {
  components: {
    orderDetailManagerList,
    medicinesList
  },
  data: () => ({
    dialog: false,
    menu: false,
    showGrid: false,
    order: {
      orderCode: "",
      providerId: "",
      scaleFee: "",
      deliveryNumber: ""
    },
    patient: {
      id: "",
      documentType: "",
      document: "",
      fullname: "",
      address: "",
      cellPhoneNumber: "",
      phoneNumber: "",
      isPac: false,
      isPolicy: false
    }
  }),
  methods: {
    handleOrder(order) {
      this.showGrid = !this.showGrid;
    },
    closeOrder() {
      this.dialog = false;
      this.showGrid = false;
    }
  }
};
